(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jw-commission-studio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jw-commission-studio')) {
  customElements.define('jw-commission-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const q = selector => this.querySelector(selector);
      const qa = selector => Array.from(this.querySelectorAll(selector));
      const form = q('form');
      const messages = JSON.parse(q('[data-messages]').textContent);
      const panels = qa('[data-panel]');
      const size = q('[data-size]');
      const orientation = q('[data-orientation]');
      const background = q('[data-background]');
      const color = q('[data-color-input]');
      const other = q('[data-other]');
      const photos = qa('[data-photo]');
      let step = 0;
      let submitting = false;
      form.noValidate = true;
      form.classList.add('is-enhanced');
      q('.jw-steps').hidden = false;
      q('.jw-swatches').hidden = false;
      const showStep = (next, focus = true) => {
        step = next;
        panels.forEach((panel, index) => panel.hidden = index !== step);
        qa('[data-step]').forEach(button => {
          if (Number(button.dataset.step) === step) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        q('[data-next]').hidden = step === 2;
        q('[data-next]').textContent = step === 0 ? messages.next : messages.review;
        q('[data-submit]').hidden = step !== 2;
        q('[data-reassure]').textContent = step === 2 ? messages.depositNote : messages.reviewNote;
        if (focus) panels[step].querySelector('h2').focus({preventScroll:false});
      };
      const syncColor = () => {
        q('[data-color-value]').textContent = color.value.toUpperCase();
        qa('[data-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === color.value)));
      };
      const syncBackground = () => {
        const solid = background.value === 'Solid / Monochrome (standard)';
        const custom = background.value === 'Other (describe below)';
        q('[data-color-wrap]').hidden = !solid;
        color.disabled = !solid;
        q('[data-other-wrap]').hidden = !custom;
        other.disabled = !custom;
        other.required = custom;
        if (!custom) other.setCustomValidity('');
      };
      const syncSize = () => {
        const option = size.selectedOptions[0];
        q('[data-total]').textContent = option.dataset.formattedTotal;
        q('[data-balance]').textContent = option.dataset.formattedDeposit;
        q('[data-deposit]').textContent = option.dataset.formattedDeposit;
        q('[data-button-price]').textContent = option.dataset.formattedDeposit;
        q('[data-submit]').disabled = option.disabled || submitting;
        const dims = option.dataset.title.match(/(\d+)\s*[×x]\s*(\d+)/);
        const square = dims && dims[1] === dims[2];
        orientation.disabled = !!square;
        q('[data-orientation-wrap]').hidden = !!square;
        q('[data-shape]').textContent = square ? messages.square : messages.rectangle;
        if (dims) {
          const ratio = Number(dims[1]) / Number(dims[2]);
          const landscape = !square && orientation.value === 'Landscape (horizontal)';
          q('[data-canvas]').style.width = (landscape ? 90 : 70 * ratio) + 'px';
          q('[data-canvas]').style.height = (landscape ? 90 * ratio : 70) + 'px';
          q('[data-canvas]').textContent = dims[1] + ' × ' + dims[2];
        }
      };
      const validate = () => {
        q('[data-error]').hidden = true;
        [q('[data-details]'), other].forEach(field => field.setCustomValidity(!field.disabled && field.required && !field.value.trim() ? messages.textError : ''));
        for (const photo of photos) {
          const file = photo.files[0];
          const invalid = file && (file.size >= 10 * 1024 * 1024 || (file.type && !file.type.startsWith('image/')));
          photo.setCustomValidity(invalid ? messages.fileError : '');
        }
        for (const input of Array.from(form.elements)) {
          if (input.willValidate && !input.checkValidity()) {
            const panel = input.closest('[data-panel]');
            if (panel) showStep(Number(panel.dataset.panel), false);
            const disclosure = input.closest('details');
            if (disclosure) disclosure.open = true;
            input.reportValidity();
            return false;
          }
        }
        return true;
      };
      const review = () => {
        const rows = [[messages.labels.canvas,size.selectedOptions[0].dataset.title]];
        if (!orientation.disabled) rows.push([messages.labels.orientation,orientation.selectedOptions[0].textContent]);
        rows.push([messages.labels.subject,q('[data-subject]').selectedOptions[0].textContent]);
        if (q('[data-subject-name]').value.trim()) rows.push([messages.labels.name,q('[data-subject-name]').value.trim()]);
        rows.push([messages.labels.photos,photos.flatMap(input => Array.from(input.files).map(file => file.name)).join('\n')]);
        rows.push([messages.labels.background,background.selectedOptions[0].textContent]);
        if (!color.disabled) rows.push([messages.labels.color,color.value.toUpperCase()]);
        if (!other.disabled) rows.push([messages.labels.background,other.value.trim()]);
        rows.push([messages.labels.idea,q('[data-details]').value.trim()]);
        if (q('[data-date]').value) rows.push([messages.labels.deadline,q('[data-date]').value]);
        const list = q('[data-review]');
        list.replaceChildren();
        rows.forEach(([label,value]) => {
          const term = document.createElement('dt');
          term.textContent = label;
          const description = document.createElement('dd');
          description.textContent = value;
          if (label === messages.labels.color) {
            const swatch = document.createElement('span');
            swatch.className = 'jw-review-color';
            swatch.style.backgroundColor = color.value;
            swatch.setAttribute('aria-hidden','true');
            description.prepend(swatch);
          }
          list.append(term,description);
        });
      };
      const go = next => {
        if (submitting) return;
        if (next === 2) {
          if (!validate()) return;
          review();
        }
        showStep(next);
      };
      qa('[data-step]').forEach(button => button.addEventListener('click', () => go(Number(button.dataset.step))));
      q('[data-next]').addEventListener('click', () => go(step + 1));
      q('[data-edit]').addEventListener('click', () => go(1));
      size.addEventListener('change', syncSize);
      orientation.addEventListener('change', syncSize);
      background.addEventListener('change', syncBackground);
      color.addEventListener('input',syncColor);
      qa('[data-color]').forEach(button => button.addEventListener('click', () => {color.value = button.dataset.color;syncColor()}));
      photos.forEach(input => input.addEventListener('change', () => {
        const file = input.files[0];
        const bad = file && (file.size >= 10 * 1024 * 1024 || (file.type && !file.type.startsWith('image/')));
        input.setCustomValidity(bad ? messages.fileError : '');
        if (bad) input.reportValidity();
      }));
      [q('[data-details]'),other].forEach(input => input.addEventListener('input', () => input.setCustomValidity('')));
      form.addEventListener('submit', event => {
        if (submitting) {event.preventDefault();return;}
        if (step !== 2) {event.preventDefault();go(Math.min(step + 1,2));return;}
        if (!validate()) {event.preventDefault();return;}
        submitting = true;
        q('[data-submit]').disabled = true;
        q('[data-submit]').textContent = messages.submitting;
        form.setAttribute('aria-busy','true');
      });
      window.addEventListener('pageshow', () => {
        if (!submitting) return;
        submitting = false;
        form.removeAttribute('aria-busy');
        q('[data-submit]').innerHTML = this.checkoutMarkup;
        syncSize();
      });
      this.checkoutMarkup = q('[data-submit]').innerHTML;
      syncSize();syncColor();syncBackground();showStep(0,false);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
